module.exports = __webpack_public_path__ + "img/av_badger.d4acb400.png";